export const REMOVE_LOGIN = 'REMOVE_LOGIN'

export const SET_REFRESH_OPTION = 'SET_REFRESH_OPTION'

export const SET_LOGIN = 'SET_LOGIN'

export const SET_AUTHOR = 'SET_AUTHOR'
